import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [userToken, setUserToken] = useState(null);
    const [loading, setLoading] = useState(true); // controle de carregamento

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setUserToken(token);
        }
        setLoading(false); // termina carregamento
    }, []);

    const login = (token) => {
        localStorage.setItem('token', token);
        setUserToken(token);
    };

    const logout = () => {
        localStorage.removeItem('token');
        setUserToken(null);
    };

    return (
        <AuthContext.Provider value={{ userToken, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};
